// OWNER: AREA-OPS (dashboard, applications/*, suppressions, audit, system). Components go in src/features/servicebus.
// Service Bus sources of an application: the list (index) and each source's page.
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/applications/$appId/service-bus')({
  staticData: { crumb: 'Service Bus' },
  component: Outlet,
})
